import type { GetServerSidePropsContext } from 'next'
import { buildSearchFromQuery, joinPath } from '../catalog/ssr'
import {
  DEFAULT_SHOP_LOCALE,
  readLocaleFromCookieHeader,
  resolveShopLocale,
  stripLocalePrefix,
} from '../i18n/shopLocale'

export const resolveRequestedPathname = (slug: unknown): string => {
  const slugSegments = Array.isArray(slug) ? slug : []
  return joinPath(slugSegments)
}

export const resolveCatchAllLocaleState = ({
  ctx,
  requestedPathname,
}: {
  ctx: GetServerSidePropsContext
  requestedPathname: string
}) => {
  const initialSearch = buildSearchFromQuery(ctx.query)
  const cookieLocale = readLocaleFromCookieHeader(ctx.req.headers.cookie)
  const resolvedLocale = resolveShopLocale({
    pathname: requestedPathname,
    cookieLocale,
    acceptLanguage: ctx.req.headers['accept-language'],
    fallbackLocale: DEFAULT_SHOP_LOCALE,
  })
  const { hadLocalePrefix, pathnameWithoutLocale, localeFromPath } =
    stripLocalePrefix(requestedPathname)

  return {
    initialSearch,
    resolvedLocale,
    hadLocalePrefix,
    pathnameWithoutLocale,
    localeFromPath,
  }
}
